module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"description-cap-price":"Se o valor total ultrapassar esse teto, cobrar o teto.","description-single-price":"Preço de cada mídia quando comprada individualmente."}}')
  delete Component.options._Ctor
}
